import { Request } from 'crono-fe-common/types/request';
import client from 'utils/clients/client';
import { ENDPOINTS } from '../../../config/endpoints';
import { OutlookSettings } from 'crono-fe-common/types/outlookSettings';

export type OutlookVerifyIntegrationResult = {
  data: { isSuccess: boolean; data: OutlookSettings | null };
};

class OutlookService {
  private _alreadyRunningVerifyOutlookIntegrationCall: Promise<OutlookVerifyIntegrationResult> | null =
    null;

  public async verifyOutlookIntegration(
    email: string,
  ): Promise<OutlookVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyOutlookIntegrationCall) {
      return await this._alreadyRunningVerifyOutlookIntegrationCall;
    } else {
      this._alreadyRunningVerifyOutlookIntegrationCall =
        this._verifyOutlookIntegration(email);
      try {
        const verifyResult =
          await this._alreadyRunningVerifyOutlookIntegrationCall;
        return verifyResult;
      } catch (e) {
        return {
          data: {
            isSuccess: false,
            data: null,
          },
        };
      } finally {
        this._alreadyRunningVerifyOutlookIntegrationCall = null;
      }
    }
  }

  private async _verifyOutlookIntegration(
    email: string,
  ): Promise<OutlookVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.outlook.verify,
      config: {
        method: 'POST',
        data: { email },
      },
    };

    const result = await client(request);
    return result as OutlookVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new OutlookService();
